import * as yup from 'yup';

import type { CampaignProps } from './completion-modal.types';

const roomCompletionFeedback = {
  like: yup.string().default(''),
  dislike: yup.string().default(''),
  feature: yup.string().default(''),
};

export const roomCompletionFeedbackValidation = yup.object(roomCompletionFeedback);
export type RoomCompletionFeedbackFormInput = yup.InferType<typeof roomCompletionFeedbackValidation>;

export const LINKEDIN_SHARE_URL = 'https://www.linkedin.com/sharing/share-offsite/';
export const TWITTER_SHARE_URL = 'https://twitter.com/intent/tweet';
export const FACEBOOK_SHARE_URL = 'https://www.facebook.com/sharer.php';

export const TRYHACKME_ROOM_URL = 'www.tryhackme.com/r/room/';

const UTM_CAMPAIGN = 'social_share';
const UTM_MEDIUM = 'social';
const UTM_SOURCE_LINKEDIN = 'linkedin';
const UTM_SOURCE_TWITTER = 'twitter';
const UTM_SOURCE_FACEBOOK = 'facebook';

export const campaignData: CampaignProps = {
  utm_campaign: UTM_CAMPAIGN,
  utm_medium: UTM_MEDIUM,
};

export const linkedinCampaignData: CampaignProps = {
  ...campaignData,
  utm_source: UTM_SOURCE_LINKEDIN,
};

export const twitterCampaignData: CampaignProps = {
  ...campaignData,
  utm_source: UTM_SOURCE_TWITTER,
};

export const facebookCampaignData: CampaignProps = {
  ...campaignData,
  utm_source: UTM_SOURCE_FACEBOOK,
};
